@let s = data;
<div class="row g-4">
  <!-- Left: Profile Card -->
  <div class="col-lg-4 col-xl-3">
    <div class="profile-card">
      <div class="profile-banner"></div>
      <div class="profile-body">
        <div class="profile-avatar-wrap">
          <div class="profile-avatar" [style.background]="s.profile_photo ? 'transparent' : getAvatarColor(s.id)">
            @if (s.profile_photo) {
            <img [src]="s.profile_photo" alt="{{ s.first_name }}">
            } @else {
            {{ getInitials(s) }}
            }
          </div>
          <span class="profile-status-dot {{ getStatusClass(s.status) }}"></span>
        </div>
        <h5 class="profile-name">{{ s.first_name }} {{ s.last_name }}</h5>
        <p class="profile-desig">{{ dataService.getDesiName(s.designation) }}</p>
        <div class="profile-tags">
          <span class="type-badge {{ getTypeClass(s.staff_type) }}">
            <i class="bi {{ getTypeIcon(s.staff_type) }} me-1"></i>{{ s.staff_type }}
          </span>
          <span class="status-badge {{ getStatusClass(s.status) }}">{{ s.status }}</span>
        </div>
        <div class="profile-stats">
          <div><span class="ps-val">{{ s.experience ?? 0 }}</span><span class="ps-label">Yrs Exp.</span></div>
          <div class="ps-divider"></div>
          <div><span class="ps-val">{{ dataService.getDeptName(s.department) }}</span><span class="ps-label">Dept</span></div>
          <div class="ps-divider"></div>
          <div><span class="ps-val">{{ s.employment!.slice(0,4) }}.</span><span class="ps-label">Type</span></div>
        </div>
        <!-- Quick Info -->
        <ul class="profile-info-list">
          <li><i class="bi bi-card-text text-primary"></i><span>{{ s.emp_code }}</span></li>
          <li><i class="bi bi-envelope-fill text-info"></i><span>{{ s.email }}</span></li>
          <li><i class="bi bi-telephone-fill text-success"></i><span>+91 {{ s.mobile }}</span></li>
          <li><i class="bi bi-calendar-check-fill text-warning"></i><span>Joined {{ formatDate(s.doj)
              }}</span></li>
          @if (s.basic_salary) {
          <li><i class="bi bi-cash-coin text-teal"></i><span>{{ formatCurrency(s.basic_salary) }}/month</span></li>
          }
        </ul>
        <!-- <div class="profile-actions">
          <button class="btn btn-outline-primary btn-sm w-100 mb-2" (click)="openEdit(s)">
            <i class="bi bi-pencil-fill me-1"></i> Edit Profile
          </button>
          <button class="btn btn-outline-danger btn-sm w-100" (click)="confirmDelete(s)">
            <i class="bi bi-trash3 me-1"></i> Delete
          </button>
        </div> -->

        <button class="btn btn-outline-success btn-sm w-100" (click)="genStaffLogin(s)"
          [disabled]="isLoginGen">
          <i class="bi bi-shield-lock"></i> Generate User Login!
        </button>
        <small class="text-danger mt-0" *ngIf="isLoginGen">
          <i class="bi bi-exclamation-triangle"></i> User already generated.
        </small>
      </div>
    </div>
  </div>

  <!-- Right: Details Tabs -->
  <div class="col-lg-8 col-xl-9">

    <!-- Personal -->
    <div class="detail-card mb-3">
      <div class="dc-header"><i class="bi bi-person-fill me-2"></i>Personal Information</div>
      <div class="dc-body">
        <div class="detail-grid">
          <div class="dg-item"><span class="dg-label">Full Name</span><span class="dg-val">{{ s.first_name }} {{
              s.lastName }}</span></div>
          <div class="dg-item"><span class="dg-label">Gender</span><span class="dg-val">{{ s.gender }}</span></div>
          <div class="dg-item"><span class="dg-label">Date of Birth</span><span class="dg-val">{{
              formatDate(s.dob) }}</span></div>
          <div class="dg-item"><span class="dg-label">Age</span><span class="dg-val">{{ calcAge(s.dob) }}</span>
          </div>
          <div class="dg-item"><span class="dg-label">Blood Group</span><span class="dg-val">{{ s.blood_group || '—'
              }}</span></div>
        </div>
      </div>
    </div>

    <!-- Contact -->
    <div class="detail-card mb-3">
      <div class="dc-header"><i class="bi bi-telephone-fill me-2"></i>Contact & Address</div>
      <div class="dc-body">
        <div class="detail-grid">
          <div class="dg-item"><span class="dg-label">Mobile</span><span class="dg-val">+91 {{ s.mobile }}</span></div>
          <div class="dg-item"><span class="dg-label">Email</span><span class="dg-val">{{ s.email }}</span></div>
          <div class="dg-item col-span-3"><span class="dg-label">Address</span><span class="dg-val">{{ [s.address,
              s.city, s.state, s.pin_code].filter(v => !!v).join(', ') || '—' }}</span></div>
        </div>
      </div>
    </div>

    <!-- Professional -->
    <div class="detail-card mb-3">
      <div class="dc-header"><i class="bi bi-briefcase-fill me-2"></i>Professional Details</div>
      <div class="dc-body">
        <div class="detail-grid">
          <div class="dg-item"><span class="dg-label">Employee ID</span><span class="dg-val fw-semibold text-primary">{{
              s.emp_code }}</span></div>
          <div class="dg-item"><span class="dg-label">Staff Type</span><span class="dg-val"><span
                class="type-badge {{ getTypeClass(s.staff_type) }}">{{ s.staff_type }}</span></span></div>
          <div class="dg-item"><span class="dg-label">Department</span><span class="dg-val">{{ dataService.getDeptName(s.department) }}</span>
          </div>
          <div class="dg-item"><span class="dg-label">Designation</span><span class="dg-val">{{ dataService.getDesiName(s.designation) }}</span>
          </div>
          <div class="dg-item"><span class="dg-label">Employment Type</span><span class="dg-val"><span
                class="emp-type-pill">{{ s.employment }}</span></span></div>
          <div class="dg-item"><span class="dg-label">Date of Joining</span><span class="dg-val">{{
              formatDate(s.doj) }}</span></div>
          <div class="dg-item"><span class="dg-label">Experience</span><span class="dg-val">{{ s.experience ?? '—' }}
              years</span></div>
          <div class="dg-item"><span class="dg-label">Basic Salary</span><span class="dg-val fw-semibold">{{
              formatCurrency(s.basic_salary) }}</span></div>
          <div class="dg-item"><span class="dg-label">Status</span><span class="dg-val"><span
                class="status-badge {{ getStatusClass(s.status) }}">{{ s.status }}</span></span></div>
        </div>
        <!-- Subjects -->
        @if (s.subjects.length) {
        <div class="mt-3">
          <p class="sub-section-label">Subjects Taught</p>
          <div class="d-flex flex-wrap gap-2">
            @for (sub of s.subjects; track sub) {
            <span class="subject-tag">{{ sub }}</span>
            }
          </div>
        </div>
        }
      </div>
    </div>

    <!-- Qualifications -->
    @if (s.qualifications.length) {
    <div class="detail-card mb-3">
      <div class="dc-header"><i class="bi bi-mortarboard-fill me-2"></i>Educational Qualifications</div>
      <div class="dc-body p-0">
        <table class="detail-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Degree</th>
              <th>Subject</th>
              <th>Institution</th>
              <th>Year</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            @for (q of s.qualifications; track q; let i = $index) {
            <tr>
              <td class="text-muted">{{ i + 1 }}</td>
              <td class="fw-semibold">{{ q.degree || '—' }}</td>
              <td>{{ q.subject || '—' }}</td>
              <td>{{ q.institution || '—' }}</td>
              <td>{{ q.yearOfPassing || '—' }}</td>
              <td>{{ q.percentage ? q.percentage + '%' : '—' }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    }

    <!-- Documents -->
    @if (s.documents.length) {
    <div class="detail-card mb-3">
      <div class="dc-header"><i class="bi bi-file-earmark-fill me-2"></i>Documents</div>
      <div class="dc-body">
        <div class="row g-2">
          @for (doc of s.documents; track doc.name) {
          <div class="col-md-4">
            <div class="doc-item" [class.uploaded]="doc.fileName">
              <i class="bi" [class.bi-file-check-fill]="doc.fileName" [class.bi-file-earmark]="!doc.fileName"
                [class.text-success]="doc.fileName" [class.text-muted]="!doc.fileName"></i>
              <div>
                <div class="small fw-semibold">{{ doc.name }}</div>
                <div class="small text-muted">{{ doc.fileName || 'Not uploaded' }}</div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <!-- Remarks -->
    @if (s.remarks) {
    <div class="detail-card">
      <div class="dc-header"><i class="bi bi-chat-text-fill me-2"></i>Remarks</div>
      <div class="dc-body">
        <p class="mb-0 text-secondary">{{ s.remarks }}</p>
      </div>
    </div>
    }

  </div>
</div>